/** Precios de carta en el cliente (espejo de pizas_pricing.py). */

export const HALF_SPECIALTY_SURCHARGE = 40;
export const SINGLE_PIZZA_RATE = 0.3;

export function isPizzaItem(item) {
  if (!item) return false;
  if (item.item_kind === 'topping_extra') return false;
  if (item.is_pizza === true || item.item_kind === 'pizza') return true;
  return Array.isArray(item.sizes) && item.sizes.length > 0;
}

export function sizePrice(item, sizeKey = 'mediana') {
  const sizes = item?.sizes || [];
  const row = sizes.find((s) => s.key === sizeKey) || sizes[0];
  if (row) return { price: Number(row.price) || 0, label: row.label || sizeKey, key: row.key };
  return { price: Number(item?.price) || 0, label: item?.size_label || '', key: sizeKey };
}

export function toppingPrice(topping, sizeKey = 'mediana') {
  const map = topping?.extra_prices_by_size || {};
  if (map[sizeKey] != null) return Number(map[sizeKey]) || 0;
  const defaults = { mediana: 30, grande: 35, familiar: 40 };
  return defaults[sizeKey] || 30;
}

export function buildCartLine({
  item,
  sizeKey = 'mediana',
  qty = 1,
  halfSpecialty = null,
  extraToppings = [],
  notes = '',
}) {
  const pizza = isPizzaItem(item);
  const { price: base, label, key } = pizza
    ? sizePrice(item, sizeKey)
    : { price: Number(item.price) || 0, label: '', key: '' };
  const halfSurcharge = pizza && halfSpecialty?.id ? HALF_SPECIALTY_SURCHARGE : 0;
  const extras = pizza
    ? (extraToppings || []).map((t) => ({
        id: t.id,
        name: t.name,
        unit_price: toppingPrice(t, key || sizeKey),
      }))
    : [];
  const extrasUnit = extras.reduce((s, t) => s + t.unit_price, 0);
  const unit_price = base + halfSurcharge + extrasUnit;
  const q = Math.max(1, Number(qty) || 1);
  return {
    menu_item_id: item.id,
    name: item.name,
    qty: q,
    size_key: key || sizeKey,
    size_label: label,
    half_specialty_id: halfSpecialty?.id || '',
    half_specialty_name: halfSpecialty?.name || '',
    half_surcharge: halfSurcharge,
    extra_toppings: extras,
    extra_topping_ids: extras.map((t) => t.id),
    unit_price,
    line_total: unit_price * q,
    notes: notes || '',
    is_pizza: pizza,
  };
}

export function lineCartKey(line) {
  const extras = (line.extra_topping_ids || line.extra_toppings || [])
    .map((t) => (typeof t === 'string' ? t : t.id))
    .filter(Boolean)
    .sort()
    .join(',');
  return [
    line.menu_item_id,
    line.size_key || '',
    line.half_specialty_id || '',
    extras,
  ].join('|');
}

export function applyAutoDiscounts(cart) {
  const units = [];
  for (const ln of cart || []) {
    if (!ln.is_pizza && ln.line_type !== 'pizza') continue;
    const q = Math.max(1, Number(ln.qty) || 1);
    const u = Number(ln.unit_price) || 0;
    for (let i = 0; i < q; i += 1) units.push(u);
  }
  const n = units.length;
  if (n <= 0) return { auto_discount: 0, detail: '', rule: '' };
  if (n === 1) {
    const d = Math.round(units[0] * SINGLE_PIZZA_RATE * 100) / 100;
    return { auto_discount: d, detail: '30% en una sola pizza', rule: 'single_30' };
  }
  const sorted = [...units].sort((a, b) => a - b);
  const free = Math.floor(n / 2);
  const d = Math.round(sorted.slice(0, free).reduce((s, x) => s + x, 0) * 100) / 100;
  return {
    auto_discount: d,
    detail: `2x1 (${free} pizza${free === 1 ? '' : 's'} gratis)`,
    rule: '2x1',
  };
}

export function cartTotals(cart, deliveryFee = 0) {
  const subtotal = (cart || []).reduce((s, c) => s + (Number(c.line_total) || 0), 0);
  const { auto_discount, detail, rule } = applyAutoDiscounts(cart);
  const total = Math.max(0, Math.round((subtotal + Number(deliveryFee || 0) - auto_discount) * 100) / 100);
  return {
    subtotal: Math.round(subtotal * 100) / 100,
    auto_discount,
    auto_discount_detail: detail,
    auto_discount_rule: rule,
    delivery_fee: Number(deliveryFee) || 0,
    total,
  };
}
